import { useCallback, useState } from 'react'

export const useSchedioSiteLayout = (args: { initialCollapsed?: boolean }) => {
	const { initialCollapsed } = args
	const [ collapsed, setCollapsed ] = useState(initialCollapsed)

	const toggle = useCallback(
		() => {
			setCollapsed(!collapsed)
		},
		[ collapsed ]
	)

	return { collapsed, toggle }
}
